"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = exports.NAVIGATION_STYLE_TYPE = void 0;
var _react = _interopRequireDefault(require("react"));
var _CardBox = require("b2b-components/theme/components/CardBox");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Group = require("./Group");
require("./Navigation.scss");
var NAVIGATION_STYLE_TYPE = /*#__PURE__*/function (NAVIGATION_STYLE_TYPE) {
  NAVIGATION_STYLE_TYPE["horizontal"] = "horizontal";
  NAVIGATION_STYLE_TYPE["vertical"] = "vertical";
  return NAVIGATION_STYLE_TYPE;
}(NAVIGATION_STYLE_TYPE || {});
exports.NAVIGATION_STYLE_TYPE = NAVIGATION_STYLE_TYPE;
var Navigation = function Navigation(_ref) {
  var className = _ref.className,
    groups = _ref.groups,
    onLinkClick = _ref.onLinkClick,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? NAVIGATION_STYLE_TYPE.vertical : _ref$styleType;
  var Group = Navigation.Group;
  var rootClassName = (0, _classnames["default"])('cds-Navigation', {
    'cds-Navigation--Horizontal': styleType === NAVIGATION_STYLE_TYPE.horizontal
  }, className);
  return /*#__PURE__*/_react["default"].createElement(_CardBox.CardBox, {
    className: rootClassName,
    titleSize: _CardBox.CARD_BOX_TITLE_SIZE["default"]
  }, Array.isArray(groups) && groups.map(function (group, index) {
    return /*#__PURE__*/_react["default"].createElement(Group, {
      key: (0, _key.createKey)(index, 'group'),
      group: group,
      onLinkClick: onLinkClick
    });
  }));
};
exports.Navigation = Navigation;
Navigation.Group = _Group.Group;
Navigation.config = {
  styleType: NAVIGATION_STYLE_TYPE
};